import React from 'react';
import { ThemeProvider } from './contexts/ThemeContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { AuthProvider } from './contexts/AuthContext';
import { LenisProvider } from './contexts/LenisContext';
import { CursorProvider } from './contexts/CursorContext';
import { CookieConsentProvider } from './contexts/CookieConsentContext';

interface ProvidersProps {
  children: React.ReactNode;
}

export const Providers: React.FC<ProvidersProps> = ({ children }) => {
  return (
    <ThemeProvider>
      <CookieConsentProvider>
        <LanguageProvider>
          <AuthProvider>
            <NotificationProvider>
              <LenisProvider>
                <CursorProvider>{children}</CursorProvider>
              </LenisProvider>
            </NotificationProvider>
          </AuthProvider>
        </LanguageProvider>
      </CookieConsentProvider>
    </ThemeProvider>
  );
};
